module.exports = __webpack_public_path__ + "src/assets/img/mstop.14305a71.svg";